export default __webpack_public_path__ + "static/media/gaugeIcon.d96c8ca1.svg";